import React, { useMemo } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { getIsPostPageBundle } from '@wix/communities-blog-client-common';
import { getCurrentSitePageTitle } from '../../store/basic-params/basic-params-selectors';
import { useSelector } from '../runtime-context';
import styles from './header-title.scss';

const HeaderTitle: React.FC = () => {
  const { t } = useTranslation();
  const title: string = useSelector(getCurrentSitePageTitle);
  const isPostPage = useSelector(getIsPostPageBundle);

  const sitePageTitleMap = useMemo(
    () => ({
      Blog: t('blog-mobile-header.title.blog'),
      Post: t('blog-mobile-header.title.post'),
      Category: t('blog-mobile-header.title.category'),
    }),
    [t],
  );

  const translatedTitle = useMemo(() => {
    if (title in sitePageTitleMap) {
      return sitePageTitleMap[title as keyof typeof sitePageTitleMap];
    }

    if (isPostPage) {
      return sitePageTitleMap.Post;
    }

    return title;
  }, [sitePageTitleMap, title, isPostPage]);

  return (
    <p className={styles.title}>
      <span>{translatedTitle}</span>
    </p>
  );
};

export default HeaderTitle;
